const mEditionAssetContentsModalEditName = {
  mEditionAssetContentsModalEditName: {
    alerts: {
      updateContenidoNodo: {
        error: 'Un error ha ocurrido. Verifica los datos ingresados y vuelve a intentarlo.',
        success: 'El nombre de contenido fue editado exitosamente.'
      }
    },

    buttonCancel: 'CANCELAR',
    buttonPrimary: 'GUARDAR',

    inputs: {
      nombre: {
        label: 'Nombre',
        message: '* De 5 a 255 caracteres'
      }
    },

    title: 'Editar Nombre',

    validation: {
      nodo: {
        nombre: {
          maxLength: 'La longitud máxima permitida es de 255 caracteres.',
          minLength: 'La longitud mínima permitida es de 5 caracteres.',
          required: 'Nombre de contenido es requerido.'
        }
      }
    }
  }
}

export default mEditionAssetContentsModalEditName
